<template>
  <div>
    <NavBar  :breadcrumbdata="breadcrumbsinfo" breadcrumbtheme="breadcrumbcss" />
    <section  class="navbarsection">
      <main>
        <div class="videosection">
            <Transition class="transition thing">
              <video-background 
                playbackRate=0.2
                :src="src"
                :poster="poster"
        
                overlay="linear-gradient(to bottom, #003, transparent)" 
                :class="`thing playercss`"
                :style="`height: 556px;`" v-show="pvisvideo === true">
              </video-background>
            </Transition>
            <div id="panorama" class="thing  gradient" v-show="pvisvideo === false">
            </div>
        </div>
        
        <div class="txtdata">
          <h1 class="rainbow-text" v-html="imagetext"></h1>
        </div>
      </main>
    </section>
    
  
  
   <div class="seven3css">
    <SeventyThirtysection :LeftsideText="transsec1text" :RightsideText="transhighlight" leftsectheme="leftseccss" />
  </div>
 
  <div v-html="transsec2text" class="interestcss">
    
  </div>

  <AllcardsSection :allcardsdata="allcardsdata"/>

<section class="sectionpadding">
  <DynamicTable :getTableCaptions="tabledata" :getjobs="careerpagejobs" :getregions="careerregions" @click.prevent="getLinkedID($event)"/>
</section>
 

  
  <AllSlides :displayedPhotos="displayedPhotos" :ophotos="ophotos" :page="page" :perPage="perPage" :pages="pages" :totalPages="totalPages"  />

    <section class="bottomsec">
      <div>
        <hr class="hrclass"/>
        <span v-html="careerbottommsg" class="hrspantext">

        </span>
      </div>
      
    </section>
    
    <section style="height: 40px;">
    </section>
    <FooterPage />
  </div>
</template>

<script>
import NavBar from '@/components/NavBar.vue';
import FooterPage from '@/components/FooterPage.vue';
import DynamicTable from '@/components/DynamicTable.vue';
import AllSlides from '@/components/AllSlides.vue';
import SeventyThirtysection from '@/components/SeventyThirtysection.vue';
import AllcardsSection from '@/components/AllcardsSection.vue';
require('@/assets/css/pannellium-2.5.css');
require('@/assets/css/video-js.css');
import axios from 'axios';
import { useRoute, useRouter } from 'vue-router'

const router = useRouter()
const route = useRoute()


export default {
  name: 'AboutView',
  components: {
  NavBar, FooterPage,  DynamicTable, AllSlides, SeventyThirtysection, AllcardsSection
},
data() {
  return {
  videoimage: [],
  imagetext: '',
  src: '',
  playrate: '',
  poster: '',
  // pvwebm: '',
  // pvmp4: '',
  pvstyle: '',
  pvsrc: '',
  pvisvideo: false,
  pvpanorama1: '',
  pvpanorama2: '',
  pvpanorama3: '',
  pvhotspot1: '',
  pvhotspot2: '',
  pvhotspot3: '',
  showVideo: false,
  showPanorama: false,

  breadcrumbsinfo: [],
  allcardsdata: [],
  aboutgeneral: [],

  transsec1text: '',
  transhighlight: '',
  transsec2text: '',
  careerbottommsg: '',

  //pagination props
  ophotos: [],
  page: 1,
  perPage: 1,
  pages: [],
  totalPages: 0,
  displayedPhotos: [],

  tabledata: [],
  careerpagejobs: [],
  careerregions: [],
  getjobposting: [],
  
  histsearchid: 0,
  publicPath: window.location.origin
  }
},
methods: {
async getPhotos() {
    await axios.get('homepageotheruploadlisting/careeroverview').then(
          response => {
          this.ophotos = response.data;
          this.totalPages = response.data.length;
        })
        .catch(response => {
            console.log(response);
        });
    },
async getLinkedID($event) {
  let lkId = $event.target.value
  let locallang = localStorage.getItem('lang')
  let vm = this
  if(locallang === 'en'){
    vm.$router.push({name: 'jobposting', params: {jobid: lkId}})
  }
  if(locallang === 'fr'){
    vm.$router.push({name: 'offredeemploi', params: {jobid: lkId}})
  }
  
  //-----------All career page jobs-------------
  await axios.get(`getuniquejob/${lkId}`).then(
        response => {
            this.getjobposting = response.data
            console.log(this.getjobposting)
      })
      .catch((error) => {
          console.log(error)
        }) 

      
}
},
created() {
        this.getPhotos();
},

async mounted() {
  let showImage = Boolean
  showImage = false
await axios.get('allpagespv/careeroverview').then(
    response => {
      this.videoimage = response.data
      
      this.imagetext = this.videoimage.pvdisplaytext 
      this.src = this.videoimage.pvsrc
      this.playrate = this.videoimage.playbackrate
      this.poster = this.videoimage.pvposter
      // this.pvsrc = this.videoimage.pvsrc
      // this.pvmp4 = this.videoimage.pvmp4
      this.pvstyle = this.videoimage.pvstyle
      this.pvisvideo = this.videoimage.pvisvideo
      this.pvpanorama1 = this.videoimage.pvpanorama1
      this.pvpanorama2 = this.videoimage.pvpanorama2
      this.pvpanorama3 = this.videoimage.pvpanorama3
      this.pvhotspot1 = this.videoimage.pvhotspot1
      this.pvhotspot2 = this.videoimage.pvhotspot2
      this.pvhotspot3 = this.videoimage.pvhotspot3

      // let pvisvideo1 = this.videoimage.pvisvideo
      // this.pvisvideo = pvisvideo1
          const config = {
          autoLoad: true,
          scenchange: true,
          compass: false,
          northOffset: -237.5,
          default: {
              firstScene: "hotspotoffice",
              sceneFadeDuration: 1000,
              autoRotate: -.6,
              setTimeout: 100,
              preview: this.poster
              
          },
          scenes: {
              hotspotoffice: {
                  hfov: 180,
                  pitch: 0,
                  yaw: 0,
                  type: "equirectangular",
                  panorama: this.pvpanorama1,
                  hotSpots: [
                      {
                          pitch: 4,
                          yaw: 21.8,
                          type: "scene",
                          sceneId: "anotherhotspot",
                          text: this.pvhotspot1,
                      }
                  ]
              },
              anotherhotspot: {
                    hfov: 180,
                    pitch: 0,
                    yaw: 90,
                    type: "equirectangular",
                    panorama: this.pvpanorama2,
                    hotSpots: [
                        {
                            pitch: 8,
                            yaw: -58,
                            type: "scene",
                            sceneId: "lasthotspot",
                            text: this.pvhotspot2,
                        }
                    ]
                },
                lasthotspot: {
                    hfov: 180,
                    pitch: 0,
                    yaw: 90,
                    type: "equirectangular",
                    panorama: this.pvpanorama3,
                    hotSpots: [
                        {
                            pitch: 8,
                            yaw: -58,
                            type: "scene",
                            sceneId: "hotspotoffice",
                            text: this.pvhotspot3,
                        }
                    ]
                },
              
            }
        };
        pannellum.viewer('panorama', config);
  })
  .catch((error) => {
        console.log(error)
      })
  
//------------breadcrumbs mappings info---------------
await axios.get('getbreadcrumbsinfo/careeroverview').then(
response => {
    this.breadcrumbsinfo = response.data
  })
  .catch((error) => {
      console.log(error)
      })  

    //-----------All invest page report data--------------
    axios.get('getallcareeroverview/').then(
    response => {
        this.investpagereport = response.data
        this.transsec1text = response.data[0].crtopinfo
        this.transsec2text = response.data[0].crmidinfo
        this.careerbottommsg = response.data[0].crbtminfo
    })
  .catch((error) => {
      console.log(error)
    }) 
  
  //------------all highlights---------------
  await axios.get('getallhiglights/careeroverview').then(
    response => {
        this.transhighlight = response.data[0].highlightdesc
  })
  .catch((error) => {
      console.log(error)
    })

//------------All Cards Section---------------
await axios.get('getallcardsectionsdata/careeroverview').then(
      response => {
          this.allcardsdata = response.data
    })
    .catch((error) => {
        console.log(error)
      })

//-----------Homepage NewsPhoto section-------------
await axios.get('newsphotos/').then(
      response => {
          this.newsphotos = response.data
          this.newsphoto = response.data[0]['newsphoto']
    })
    .catch((error) => {
        console.log(error)
      })  

//-----------All career table captions-------------
await axios.get('getallcareertablecaption/').then(
      response => {
          this.tabledata = response.data
    })
    .catch((error) => {
        console.log(error)
      })  
  
//-----------All regions-------------
await axios.get('getallcareerallregions/').then(
      response => {
          this.careerregions = response.data
    })
    .catch((error) => {
        console.log(error)
      }) 
  
//-----------All career page jobs-------------
await axios.get('getallcareerspagejobs/').then(
      response => {
          this.careerpagejobs = response.data
    })
    .catch((error) => {
        console.log(error)
      }) 


}
}
</script>

<style scoped>
.stockcards {
  padding-top: 200px;
}

.container {
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: .2fr 1.2fr .2fr;
  grid-template-areas: 
  "nav nav nav" 
  "main main main" 
  "footer footer footer";
  grid-gap: 0.2rem;
  font-family: "Inter", sans-serif;
  font-size: 800;
  font-size: 12px;
  color: #234234;
  text-align: center;
}

html { 
  height: 100%;
  margin:0px;
  background: url('../assets/slide-5.jpg') no-repeat center center;
  background-size: cover;
  background-attachment: fixed;
}

main {
  background: white;
  grid-area: main;
  padding-left: 0px;
  padding-right: 0px;
  margin-left: 0px;
  margin-right: 0px;
  border-radius: 0px;
  margin-top:-5px;
}

.yearscontainer {
  background-color: grey;
  margin-top: -200px;
 }
.yearscontainergifbtm {
  margin-bottom: 20px;
}
.bottomsec{
  font-size: 18px;
  text-align: justify;
  border-top: solid thin grey;
  padding: 100px;
}
.hrspantext {
  padding-top: 10px;
}
.stockcss {
  margin-top: 100px;
  width: 70%;
}
.stockcss1 {
  margin-top: -190px;
  width: 70%;
}

/*===================MEDIA SCREENS TAMPLATES===============*/
 /* Extra small devices (phones, 600px and down) */
 @media only screen and (max-width: 600px) {
  .bottompagemsg{
    margin-bottom: -350px;
    text-align: justify;
    padding-left: 30px;
    padding-right: 30px;
  }

  .stockcss {
    width: 98%;
    margin-top: 100px;
    margin: 0 auto;
    padding: 20px;   
    }
  .pantopsection {
    margin-top: 100px;
   }
   .txtdata {
    margin-bottom: 100px;
    width: 400px;
    padding-right: 10px;
  }  
  .seven3css {
    margin-top: 200px;
  }
  .bottomsec, .interestcss {
    padding-left: 30px;
    padding-right: 30px;
  }
 }
.sectionpadding {
  overflow-y: scroll;
}
 /* Small devices (portrait tablets and large phones, 600px and up) */
 @media only screen and (min-width: 600px) {
  .bottompagemsg{
    margin-bottom: -200px;
    text-align: justify;
    padding-left: 30px;
    padding-right: 30px;
  }
  .stockcss {
    width: 98%;
    margin-top: 100px;
    margin: 0 auto;
    padding: 20px;   
    }
  .pantopsection {
    margin-top: 100px;
   }
   .txtdata {
    margin-bottom: 200px;
    width: 600px;
    padding-right: 10px;
  }
  .seven3css {
    margin-top: 200px;
  }
  .bottomsec {
    padding-left: 30px;
    padding-right: 30px;
  }
 }
 
 /* Medium devices (landscape tablets, 768px and up) */
 @media only screen and (min-width: 768px) {
  .bottompagemsg{
    margin-bottom: -200px;
    text-align: justify;
    padding-left: 30px;
    padding-right: 30px;
  }
 
  .txtdata {
    margin-bottom: 30px;
    width: 700px;
    padding-right: 10px;
  }
  .pantopsection {
    margin-top: 250px;
   }
 }

 /* Large devices (laptops/desktops, 992px and up) */
 @media only screen and (min-width: 992px) {
  .bottomsec{
    text-align: justify;
    padding-left: 100px;
    padding-right: 100px;
  }
  .panimagesize {
    margin-top: 130px;
  }
  .interestcss {
    padding: 100px;
  }
  .txtdata {
    margin-bottom: 30px;
    width: 800px;
    padding-right: 10px;
  }

 }
 
 /* Extra large devices (large laptops and desktops, 1200px and up) */
 @media only screen and (min-width: 1200px) {
  .bottompagemsg{
    margin-bottom: -100px;
    text-align: justify;
    padding-left: 30px;
    padding-right: 30px;
  }
  .pantopsection {
    margin-top: 100px;
  }
  .txtdata {
    margin-bottom: 100px;
    width: 900px;
    padding-right: 10px;
  }
  .sectionpadding {
    padding-left: 120px;
    padding-right: 120px;
    padding-top: 100px;
    padding-bottom: 100px;
  }
 } 

  /* Extra large devices (large laptops and desktops, 1200px and up) */
  @media only screen and (min-width: 1400px) {
  .txtdata {
    margin-top: -100px;
    margin-bottom: 100px;
    width: 600px;
  }
  .stockcss {
    width: 68%;
    margin-top: 100px;
    margin: 0 auto;
    padding: 20px;   
    }
  .pantopsection {
    margin-top: 100px;
   }
  } 

</style>
